import { CALL_SCRIPTS } from 'utils/reducers';

const initialState = {
    show: false,
};

const showCallScriptsReducer = (state = initialState, action) => {
    switch (action.type) {
        case CALL_SCRIPTS.display:
            return { ...state, show: true };
        case CALL_SCRIPTS.hide:
            return { ...state, show: false };
        default:
            return state;
    }
};

export default showCallScriptsReducer;
